import { format, getDay, parse, startOfWeek } from 'date-fns';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import enUS from 'date-fns/locale/en-US';

const locales = {
  'en-US': enUS,
};
export const reactBigCalendarLocalizer = dateFnsLocalizer({
  format: (date, formatString, culture) => {
    if (formatString === 'MMMM') {
      // Convert the month to Hebrew
      const monthNames = [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
      ];

      return monthNames[date.getMonth()];
    }
    return format(date, formatString, { locale: locales[culture] });
  },
  parse,
  startOfWeek,
  getDay,
  locales,
});
